// extracted by mini-css-extract-plugin
module.exports = {"main":"Navigation_main__2RwZZ","open":"Navigation_open__19j4y"};